import React from "react";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";
import i18n from "i18next";
import { letterFromNumber } from "../../../common/common_tools";
import { setRgbaAlpha } from "../../../common/common_tools";
import { correctArrayOrdered } from "../../../core/visor/correction_functions";
import TrueFalseVisor from "../TrueFalseVisor";

/* eslint-disable react/prop-types */

export function TrueFalse() {
  return {
    getRenderTemplate: function (state, props) {
      return <TrueFalseVisor state={state} props={props} />;
    },
    checkAnswer(current, correct, state) {
      return correctArrayOrdered(current, correct, state.nBoxes, state.allowPartialScore);
    },
  };
}
/* eslint-enable react/prop-types */
